module.exports = (fox) => {
  var _ = {
    placeholders: {
      N: '[0-9]',
      A: '[A-Z]',
      W: '[0-9A-Z]',
      '[': '[',
      ']': ']',
      '-': '-',
      '*': '\\S+',
    },

    createVariant: function (pattern) {
      let str = '',
        isEnumerating = false;
      const length = pattern.length;

      for (let i = 0; i < length; i++) {
        const key = pattern.charAt(i);

        if ((isEnumerating && ['N', 'A', 'W'].includes(key)) || !(key in _.placeholders)) {
          str += key;
          continue;
        }

        if (isEnumerating && key === '-') {
          str += `\\-`;
          continue;
        }

        if (['[', ']'].includes(key)) {
          isEnumerating = key === '[';
        }

        str += _.placeholders[key];
      }

      return str;
    },

    createPattern: function (...patterns) {
      const variants = patterns.map(_.createVariant);

      return [new RegExp(`^${variants.length > 1 ? `(${variants.join('|')})` : variants}$`, 'i'), patterns.join(' | ')];
    },
  };

  const eightDigits = _.createPattern('N'.repeat(8));
  const nineDigits = _.createPattern('N'.repeat(9));
  const tenDigits = _.createPattern('N'.repeat(10));
  const elevenDigits = _.createPattern('N'.repeat(11));
  const franceRelatedIndividual = _.createPattern('[0123]' + 'N'.repeat(12));

  const tin = {
    AT: [nineDigits, nineDigits],
    BE: [elevenDigits, tenDigits],
    BG: [tenDigits, nineDigits],
    HR: [elevenDigits, elevenDigits],
    CY: [_.createPattern('NNNNNNNNA'), _.createPattern('NNNNNNNNA')],
    CZ: [_.createPattern('NNNNNNNNNN?'), _.createPattern('CZNNNNNNNNN?N?')],
    DK: [tenDigits, eightDigits],
    EE: [elevenDigits, eightDigits],
    FI: [_.createPattern('N'.repeat(6) + '[+-A]?NNNW?'), _.createPattern('N'.repeat(7) + '-N')],
    FR: [franceRelatedIndividual, nineDigits],
    RE: [franceRelatedIndividual, nineDigits],
    MQ: [franceRelatedIndividual, nineDigits],
    GP: [franceRelatedIndividual, nineDigits],
    GF: [franceRelatedIndividual, nineDigits],
    YT: [franceRelatedIndividual, nineDigits],
    DE: [elevenDigits, _.createPattern('N'.repeat(10) + 'N?'.repeat(3))],
    GR: [nineDigits, nineDigits],
    HU: [tenDigits, elevenDigits],
    IE: [_.createPattern('N'.repeat(7) + 'AA?'), _.createPattern('N'.repeat(7) + 'AA?', 'CHYN' + 'N?'.repeat(4))],
    IT: [_.createPattern('A'.repeat(6) + 'NNANNANNNA'), elevenDigits],
    LV: [elevenDigits, _.createPattern('[945]' + 'N'.repeat(10))],
    LT: [_.createPattern('N'.repeat(10) + 'N?'), _.createPattern('N'.repeat(9) + 'N?')],
    LU: [_.createPattern('N'.repeat(13)), elevenDigits],
    MT: [_.createPattern('N'.repeat(7) + 'A', 'N'.repeat(9)), nineDigits],
    NL: [nineDigits, nineDigits],
    PL: [_.createPattern('N'.repeat(10) + 'N?'), tenDigits],
    PT: [nineDigits, nineDigits],
    RO: [_.createPattern('N'.repeat(13)), _.createPattern('NN' + 'N?'.repeat(8))],
    SK: [tenDigits, tenDigits],
    SI: [eightDigits, eightDigits],
    ES: [
      _.createPattern('N'.repeat(8) + 'A', '[LKXYZM]' + 'N'.repeat(7) + 'A'),
      _.createPattern('A' + 'N'.repeat(8), 'A' + 'N'.repeat(7) + 'A'),
    ],
    SE: [tenDigits, tenDigits],
    GB: [
      _.createPattern('N'.repeat(10), 'AA' + 'N'.repeat(6) + '[ABCD]'),
      _.createPattern('N'.repeat(10), 'AA' + 'N'.repeat(6) + '[ABCD]'),],
  };

  fox.registerWidget(
    'PaymentFieldsValidation',
    {
      configure: function () {
        this.registerOptions('', {});

        this.callParent('configure', arguments);
      },

      tinValidate: function (value, country, userState) {
        var rule = tin[country];

        if (rule === undefined) {
          return { result: false, message: '' };
        }

        var regexp = rule[userState === 'individual' ? 0 : 1];

        return {
          result: regexp[0].test(value),
          message: regexp[1],
        };
      },
    },
    'Controller',
  );
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/account/paymentFieldsValidation.es.js